var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFileText = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M4.667 11.333c0-.368.298-.666.666-.666h5.334a.667.667 0 0 1 0 1.333H5.333a.667.667 0 0 1-.666-.667ZM4.667 8.667c0-.368.298-.667.666-.667h5.334a.667.667 0 0 1 0 1.333H5.333a.667.667 0 0 1-.666-.666ZM4.667 6c0-.368.298-.667.666-.667h1.334a.667.667 0 1 1 0 1.334H5.333A.667.667 0 0 1 4.667 6Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M2.586 1.253A2 2 0 0 1 4 .667h5.333c.177 0 .347.07.472.195l4 4a.666.666 0 0 1 .195.471v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2.667a2 2 0 0 1 .586-1.414ZM4 2a.667.667 0 0 0-.667.667v10.666A.667.667 0 0 0 4 14h8a.667.667 0 0 0 .667-.667V6H9.333a.667.667 0 0 1-.666-.667V2H4Zm6 .943 1.724 1.724H10V2.943Z",
  clipRule: "evenodd"
})));
SvgFileText.viewBox = null;
const ForwardRef = /*#__PURE__*/forwardRef(SvgFileText);
export default ForwardRef;